import { Fragment } from "react";
import { Primary } from "../../buttons/navigation/Primary";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { navAccess } from "../options/MenuOptions"

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Access() {
  const hasToken = localStorage.getItem('token');

  return (

    <Fragment>
      {hasToken ? <></>
        :
        <Menu as="div" className="relative text-tdark">
          <div>
            <div>
              <Menu.Button as="div" className="h-full">
                <Primary
                  text="Ingresa"
                  icon={<ChevronDownIcon className="w-4 h-4" />}
                />
              </Menu.Button>
            </div>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="lg:absolute right-0 mt-2 w-52 rounded-md shadow-lg py-1 bg-white ring-1 ring-red/5 focus:outline-hidden">
              <Menu.Item>
                {({ active }) => (
                  <div
                    className={classNames(active ? "bg-white" : "", "text-sm")}
                  >
                    <div>
                      <div className="px-4 py-2">
                        {navAccess.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className="block py-2 hover:font-bold"
                          >
                            {item.name}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      }

    </Fragment>

  );
}
